export const isLocal = (() => {
  try {
    return import.meta.env.MODE === 'development';
  } catch (error) {
    return false;
  }
})();
